import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("nro_doc", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nro_doc + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("item", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.item + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.item + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombre", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombre + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("unidad", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.unidad + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado_ficha", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado_ficha + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            return cf.runFilters();
        },

        filterNroDoc(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_doc: val
            });
        },
        filterItem(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                item: val
            });
        },
        filterNombre(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre: val
            });
        },
        filterUnidad(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                unidad: val
            });
        },
        filterEstadoFicha(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado_ficha: val
            });
        },
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_doc: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombre: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                unidad: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                item: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado_ficha: ""
            });
          
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/v_listaficha/mixins/filtros.js